import React from "react";
import { useDayPlan } from "../../DayPlanProvider";
import { DayNavigation } from "./DayNavigation";
import { ActionButtons } from "./ActionButtons";

export const ControlPanel: React.FC = () => {
  const { offerDays, currentDayIndex } = useDayPlan();
  const currentDay = offerDays[currentDayIndex];

  if (!currentDay) {
    return (
      <div className="bg-white border-b border-gray-200 px-6 py-4">
        <div className="text-center text-gray-500">Brak danych o dniu</div>
      </div>
    );
  }

  const formatDate = (date: string) => {
    const d = new Date(date);
    const dayName = d.toLocaleDateString("pl-PL", { weekday: "long" });
    const formattedDate = d.toLocaleDateString("pl-PL", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
    return `${formattedDate}, ${dayName}`;
  };

  return (
    <div className="bg-white border-b border-gray-200">
      <div className="px-6 py-4">
        {/* Header */}
        <div className="flex items-center justify-between mb-4">
          <div className="text-lg font-medium text-gray-700">
            📊 Plan na Dzień {currentDay.dayNumber} (
            {formatDate(currentDay.date)})
          </div>
        </div>

        {/* Navigation and Actions */}
        <div className="flex items-center justify-between">
          <DayNavigation />
          <ActionButtons />
        </div>
      </div>
    </div>
  );
};
